import api from './api'

// Users
export const getCurrentUser = () => api.get('users/me/')
export const updateCurrentUser = (data: object) => api.patch('users/me/', data)

// Accounts
export const listAccounts = () => api.get('accounts/')
export const getAccount = (id: number) => api.get(`accounts/${id}/`)
export const partialUpdateAccount = (id: number, data: object) =>
  api.patch(`accounts/${id}/`, data)
export const endAccountTrial = (id: number) =>
  api.post(`accounts/${id}/end_trial/`)
export const dismissPropertyIntro = (id: number) =>
  api.post(`accounts/${id}/dismiss_property_intro/`)
export const getAccountStats = (id: number, params?: { offset?: number }) =>
  api.get(`accounts/${id}/stats/`, { params })
export const getAccountStatsOrigin = (id: number) =>
  api.get(`accounts/${id}/stats_origin/`)
export const getSetupIntent = (id: number) =>
  api.get(`accounts/${id}/setup_intent/`)

// Properties
export const listProperties = () => api.get('properties/')
export const getProperty = (id: number) => api.get(`properties/${id}/`)
export const getPropertyStats = (id: number, params?: { offset?: number }) =>
  api.get(`properties/${id}/stats/`, { params })
export const getPropertyStatsOrigin = (id: number) =>
  api.get(`properties/${id}/stats_origin/`)
export const createProperty = (data: object) => api.post('properties/', data)
export const updateProperty = (id: number, data: object) =>
  api.put(`properties/${id}/`, data)
export const deleteProperty = (id: number) => api.delete(`properties/${id}/`)

// Domains
export const listDomains = () => api.get('domains/')
export const getDomain = (id: number) => api.get(`domains/${id}/`)
export const createDomain = (data: object) => api.post('domains/', data)
export const updateDomain = (id: number, data: object) =>
  api.put(`domains/${id}/`, data)
export const deleteDomain = (id: number) => api.delete(`domains/${id}/`)

// API Keys
export const getApiKey = (key: string) => api.get(`api_keys/${key}/`)
export const recycleApiKey = (key: string) =>
  api.post(`api_keys/${key}/recycle/`)
export const createApiKey = (property_id: number) =>
  api.post('api_keys/', { property_id })
export const deleteApiKey = (key: string) => api.delete(`api_keys/${key}/`)

// Subscriptions
export const listSubscriptions = () => api.get('subscriptions/')
export const getSubscription = (id: number) => api.get(`subscriptions/${id}/`)
export const cancelSubscription = (id: number, data: object) =>
  api.post(`subscriptions/${id}/cancel/`, data)
export const uncancelSubscription = (id: number) =>
  api.post(`subscriptions/${id}/uncancel/`)
export const getCurrentSubscription = () => api.get('subscriptions/current/')

// Notifications
export const listNotifications = () => api.get('notifications/')
export const dismissNotification = (id: number) =>
  api.post(`notifications/${id}/dismiss/`)
